import React, { useCallback, useState, useEffect } from "react";
import {
  FormLayout,
  TextField,
  Card,
  Page,
  TextStyle,
  Select,
  PageActions,
  Loading,
  Toast,
} from "@shopify/polaris";
import NavigationLayout from "../Components/NavigationLayout";
import axios from "../Assets/Lib/axios";
import history from "../Assets/Lib/history";

export default function AddPointAmbassador() {
  const [selectedPhase, setSelectedPhase] = useState("");
  const handleSelectChangePhase = useCallback((value) => {
    setSelectedPhase(value);
    setPhaseError("");
  });
  const optionsPhase = [
    { label: "Phase 1", value: "1" },
    { label: "Phase 3", value: "3" },
  ];
  const [phaseError, setPhaseError] = useState("");
  const [selectedAmbassador, setSelectedAmbassador] = useState("");
  const handleSelectChangeAmbassador = useCallback((value) => {
    setSelectedAmbassador(value);
    setAmbassadorError("");
  });

  const [optionsAmbassador, setOptionsAmbassador] = useState([]);
  const [ambassadorError, setAmbassadorError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const toastMarkup = active ? (
    <Toast content="Point added successfully" onDismiss={toggleActive} />
  ) : null;
  useEffect(() => {
    axios
      .get(`admin/v1/ambassadors?per_page=1000000`)
      .then((result) => {
        result?.data?.data?.data &&
          setOptionsAmbassador(
            result.data.data.data.map((item, index) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            })
          );
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <NavigationLayout>
      <Page title="Add Point Ambassador">
        {isSaving ? <Loading /> : null}
        <Card sectioned>
          <FormLayout>
            <TextStyle variation="strong">Ambassador</TextStyle>
            <Select
              options={optionsAmbassador}
              onChange={handleSelectChangeAmbassador}
              value={selectedAmbassador}
              placeholder="Please select a Ambassador"
              error={ambassadorError}
            />
            {/* <TextStyle variation="strong">Phase</TextStyle>
            <Select
              options={optionsPhase}
              onChange={handleSelectChangePhase}
              value={selectedPhase}
              placeholder="Please select a Phase"
              error={phaseError}
            /> */}
          </FormLayout>
        </Card>
        <PageActions
          primaryAction={{
            content: "Submit",
            onClick: handleSubmit,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    </NavigationLayout>
  );
  function handleSubmit() {
    if (selectedAmbassador === "") {
      selectedAmbassador === "" &&
        setAmbassadorError("Please select a ambassador");
    } else {
      setIsSaving(true);
      const form_data = new FormData();

      selectedAmbassador !== "" &&
        form_data.append("ambassador_id", selectedAmbassador);
      axios
        .post("admin/v1/ambassadors/points/add", form_data)
        .then((res) => {
          setIsSaving(false);
          toggleActive();
          //history.push("/admin/ambassadors");
        })
        .catch((err) => console.log(""));
    }
  }
}
